export default __webpack_public_path__ + "static/media/Denmark-vs-Finland.2dd45a20.jpeg";